/* eslint-disable */
/* this file is generated by generateIcons script */

import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class WindowsIcon extends BaseIcon {
  getChildren = () => [
    <g fill='#00ADEF' >
      <path d="M22.2,5.5C30.1,4.2,38,3.1,46,2c0,7,0,13.9,0,20.8c-7.9,0-15.9,0.2-23.8,0.2C22.2,17.2,22.2,11.3,22.2,5.5z"/>
      <path d="M2,8.3c6-0.9,12-1.7,18-2.5c0,5.8,0,11.5,0,17.3c-6,0-12,0.1-18,0.1V8.3z"/>
      <path d="M2,25c6,0,12,0.1,18,0.1c0,5.8,0,11.6,0,17.3c-6-0.9-12-1.7-18-2.5V25z"/>
      <path d="M22.1,25.2H46c0,6.9,0,13.9,0,20.8c-7.9-1.2-15.9-2.3-23.8-3.4C22.1,36.8,22.1,31,22.1,25.2L22.1,25.2z"/>
    </g>
  ]
  getViewBox = () => '0 0 48 48'
}
